var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKeineSelected = function SvgKeineSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    clipRule: "evenodd",
    fill: "none",
    cx: 28,
    cy: 36,
    r: 19.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M37.753 42.243 31.51 36l6.243-6.243a2.479 2.479 0 0 0-.006-3.504 2.479 2.479 0 0 0-3.504-.007L28 32.489l-6.243-6.243a2.479 2.479 0 0 0-3.504.007 2.479 2.479 0 0 0-.007 3.504L24.489 36l-6.243 6.243a2.479 2.479 0 0 0 .007 3.504 2.479 2.479 0 0 0 3.504.007L28 39.511l6.243 6.243a2.479 2.479 0 0 0 3.504-.007c.969-.97.971-2.538.006-3.504z"
  }))));
};
export default SvgKeineSelected;